module.exports = "data:image/png;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJzdGF0aWMvaWNvbnMvYW5kcm9pZC1jaHJvbWUtMTkyeDE5Mi5wbmciOw=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/android-chrome-192x192.png
// module id = mCmH
// module chunks = 0